import GeneralError from 'components/GeneralError/GeneralError';
import * as Sentry from '@sentry/nextjs';
import { NextPageContext } from 'next';
function ErrorHandler() {
  return <GeneralError data-sentry-element="GeneralError" data-sentry-component="ErrorHandler" data-sentry-source-file="_error.tsx" />;
}
ErrorHandler.getInitialProps = async (contextData: NextPageContext) => {
  const res = contextData.res;
  const err = contextData.err;

  //https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/#react-render-errors-in-pages-router
  await Sentry.captureUnderscoreErrorException(contextData);
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return {
    statusCode
  };
};
export default ErrorHandler;